<script>
// Divii's date picker, in the compact shape this feature needs.
//
// Mirrors the props PensionCalculator.vue already uses: display MM-DD-YYYY,
// emit 'YYYY-MM-DD'. `value-type` is the important one — it makes the picker
// hand back a plain calendar string rather than a Date, so nothing here ever
// touches toISOString() and no timezone shift can move a date across a day
// boundary. The feature stores 'YYYY-MM-DD' throughout, so this is a straight
// swap for the native <input type="date"> it replaces.
//
// Deliberately not Form/DateInput.vue: that one parses to a Date and emits
// `.toISOString()` (UTC), renders a full-width b-row/b-col labelled block, and
// pulls in moment plus Vuex role state. None of that fits a dense grid cell.
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: 'DateField',
	components: { DatePicker },
	props: {
		value: { type: String, default: '' },
		disabled: { type: Boolean, default: false },
		placeholder: { type: String, default: 'mm-dd-yyyy' },
		// The picker popup is portalled to <body> so it is never clipped by a
		// scrolling grid cell or the edit modal's scrollable body.
		appendToBody: { type: Boolean, default: true },
	},
	methods: {
		onInput(val) {
			this.$emit('input', val || '');
		},
	},
};
</script>

<template>
	<date-picker
		class="ps-date-field"
		type="date"
		format="MM-DD-YYYY"
		value-type="YYYY-MM-DD"
		:value="value || null"
		:placeholder="placeholder"
		:disabled="disabled"
		:append-to-body="appendToBody"
		:editable="true"
		:clearable="false"
		@input="onInput"
	/>
</template>

<style scoped>
/* Match the feature's own inputs rather than the form pages': same border,
   radius and type scale as .details-grid input. */
.ps-date-field {
	width: 100%;
	min-width: 0;
}
.ps-date-field >>> .mx-input {
	background: #fff;
	border: 1px solid #cbd5e1;
	border-radius: 6px;
	box-shadow: none;
	color: #1e293b;
	font-family: inherit;
	font-size: 0.85rem;
	height: auto;
	padding: 0.4rem 0.55rem;
}
.ps-date-field >>> .mx-input:focus {
	border-color: #3f6772;
	outline: none;
}
.ps-date-field >>> .mx-input:disabled {
	background: #f1f5f9;
	color: #94a3b8;
	cursor: not-allowed;
}
.ps-date-field >>> .mx-icon-calendar {
	color: #64748b;
}
</style>
